<template>
  <div class="container mt-5 px-4">
    <div class="row justify-content-center">
      <!-- Sidebar / Menu -->
      <div class="col-lg-4 col-md-5 mb-4">
        <div class="card shadow-sm border-0 rounded-3 overflow-hidden">
          <div class="card-body p-0">
            <div class="text-center p-4 bg-light border-bottom">
              <div class="avatar-circle mx-auto bg-primary text-white d-flex align-items-center justify-content-center fs-1 fw-bold shadow-sm">
                {{ $store.getters.getUserInfo.name ? $store.getters.getUserInfo.name.charAt(0).toUpperCase() : 'U' }}
              </div>
              <h4 class="fw-bold mt-3 mb-1 text-dark">{{ $store.getters.getUserInfo.name }}</h4>
              <p class="text-muted small mb-0">{{ $store.getters.getUserInfo.userType }}</p>
            </div>
            
            <div class="list-group list-group-flush p-3">
              <button class="list-group-item list-group-item-action active border-0 rounded-2 mb-2 d-flex align-items-center">
                <span class="icon-wrapper me-3 d-flex align-items-center justify-content-center rounded">
                  <font-awesome-icon :icon="['fas', 'user']" />
                </span>
                Profile Information
              </button>
              <button @click="$router.push('password-change')" class="list-group-item list-group-item-action border-0 rounded-2 d-flex align-items-center text-muted">
                <span class="icon-wrapper me-3 d-flex align-items-center justify-content-center rounded">
                  <font-awesome-icon :icon="['fas', 'lock']" />
                </span>
                Change Password
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Main Content -->
      <div class="col-lg-8 col-md-7">
        <div class="card shadow-sm border-0 rounded-3 h-100">
          <div class="card-header bg-white border-bottom-0 pt-4 pb-0 px-4">
            <h4 class="fw-bold mb-0 text-dark">Personal Details</h4>
          </div>
          <div class="card-body p-4">
            <div class="row align-items-center mb-4">
              <div class="col-sm-3 text-muted fw-semibold">Full Name</div>
              <div class="col-sm-9 text-dark">{{ $store.getters.getUserInfo.name }}</div>
            </div>
            <hr class="text-muted opacity-10">
            <div class="row align-items-center mb-4">
              <div class="col-sm-3 text-muted fw-semibold">User Role</div>
              <div class="col-sm-9">
                <span class="badge bg-primary text-white px-3 py-2 rounded-pill fw-semibold">
                  {{ $store.getters.getUserInfo.userType }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Profile"
}
</script>

<style scoped>
.avatar-circle {
  width: 90px;
  height: 90px;
  border-radius: 50%;
}
.list-group-item.active {
  background-color: #e9ecef;
  color: #0d6efd !important;
  font-weight: 600;
}
.list-group-item.active .icon-wrapper {
  background-color: #0d6efd;
  color: white;
}
.list-group-item .icon-wrapper {
  width: 32px;
  height: 32px;
  background-color: #f8f9fa;
  color: #6c757d;
  transition: all 0.2s ease-in-out;
}
.list-group-item:hover:not(.active) {
  background-color: #f8f9fa;
  color: #212529 !important;
}
.list-group-item:hover:not(.active) .icon-wrapper {
  background-color: #e9ecef;
  color: #212529;
}
</style>